import Template from '../../component/Template.js';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Api from '../../component/Api.js';
import { Link } from 'react-router-dom';
import React, { useRef } from "react";
import PDFModal from '../../component/PDFModal.js';
import AddExpertCommitteeConvenor from './AddExpertCommitteeConvenor.js';
import Select from 'react-select';

import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
export default function ExpertCommitteeConvenorList() {
  const tableRef = useRef(null);
  const capitalizeFirstLetter = (value) => {
    const text = String(value ?? '').trim();
    if (!text) return '';
    return text.charAt(0).toUpperCase() + text.slice(1);
  };
  {/*------------------------------------*/ }
  /* CUSTOM DATA TABLE BEGIN HERE */
  const [tableData, setTableData] = useState([]);
  const [sortBy, setSortBy] = useState({ column: null, direction: 'asc' }); //sort
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredAndSortedData, setfilteredAndSortedData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total_count, setTotal] = useState(null);
  const [reload, setReload] = useState(false);
  const [isDeleteUser, setDeleteUser] = useState(false);
  const [deleteUserID, setDeleteUserID] = useState(null);
  const [isPDFModalOpen, setIsPDFModalOpen] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [expertCommitteeData, setExpertCommitteeData] = useState([]); 
  const [selectedExpertCommittee, setSelectedOption] = useState([]);
  const [goClicked, setSearchClicked] = useState(false);
  const [clearClicked, setClearClicked] = useState(false);
  const [updatingUser, setUpdatingUser] = useState(null);
  /* CUSTOM DATA TABLE END HERE */
  const { http } = Api();
  const navigate = useNavigate();
  const isAuth = useAuth();
  if (isAuth === false) {
    navigate("/admin/");
  } 
  useEffect(() => {
    const fetchExpertCommitteeList = async () => {
      try {
        const response = await http.get('/Admin/expert-committee-convenor/getExpertCommitteeList');
         setExpertCommitteeData(response.data.data);
      } catch (error) {
        if (error.response?.data?.http_status === 403 && error.response.data.status_code === "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/admin/");
          }, 5000);
        } else if (error.response?.data?.http_status === 429 && error.response.data.status_code === "ERR33") {
          toast.error(error.response.data.message);
        } else {
          toast.error(error.response?.data?.message || "An error occurred.");
        }
      }
    };

    fetchExpertCommitteeList();
  }, []);

  const getConvenorListList = () => {
    setSearchClicked(prev => !prev); // toggle to re-trigger useEffect
  };  
  useEffect(() => {
    const getExpertCommitteeConvenorList = () => {
      http.get('/Admin/expert-committee-convenor', {       
          params: {
              expertId: selectedExpertCommittee || null
          }
     })
        .then((response) => {
          console.log("response", response);
          setTableData(response.data.data);
        })
        .catch((error) => {
          const err = error.response?.data;
          if (err?.http_status === 401 && err?.status_code === "ERR9") {
            toast.error("Invalid Token");
            setTimeout(() => {
              navigate("/admin/");
            }, 5000);

          } else if (err?.http_status === 429 && err?.status_code === "ERR33") {
            toast.error(err.message);

          } else {
            toast.error("Something went wrong");
          }
        });
    };
    getExpertCommitteeConvenorList();

  }, [goClicked,reload,clearClicked]);
  const handleClearFields = () => {
    setSelectedOption([]);
    setClearClicked(prev => !prev);
  }
  /* DATA TABLE  For this page only */
  const handleSearchInputChange = (event) => {
    setSearchQuery(event.target.value);
  };
  const handleSort = (column) => {
    const newSortBy = {
      column,
      direction: sortBy.column === column && sortBy.direction === 'asc' ? 'desc' : 'asc',
    };
    setSortBy(newSortBy);
  };
  //sorting this page : combined column
  const getSortValue = (item, column) => {   
    return (item[column] ?? '').toString().toLowerCase();
  };
  useEffect(() => {
    const search = searchQuery.toLowerCase();
    let data = [...tableData].filter(item => 
      String(item.name ?? '').toLowerCase().includes(search) ||
      String(item.email ?? '').toLowerCase().includes(search) ||
      String(item.mobile ?? '').toLowerCase().includes(search) ||
      String(item.landline ?? '').toLowerCase().includes(search) ||
      String(item.committee?.expert_committee_name ?? '').toLowerCase().includes(search) ||
      String(item.year ?? '').toLowerCase().includes(search) ||
      String(item.status ?? '').toLowerCase().includes(search)
    );
    //SORTING
    data.sort((a, b) => {
      const valA = getSortValue(a, sortBy.column);
      const valB = getSortValue(b, sortBy.column);

      if (sortBy.direction === 'asc') {
        return valA > valB ? 1 : -1;
      } else {
        return valA < valB ? 1 : -1;
      }
    });
    const itemsPerPage = 50;
    const startIndex = (currentPage - 1) * itemsPerPage;
    setfilteredAndSortedData(data.slice(startIndex, startIndex + itemsPerPage));
    setTotalPages(Math.ceil(data.length / itemsPerPage));
    setTotal(data.length);

  }, [searchQuery, sortBy, tableData, currentPage]);
  const renderSortIcon = (columnName) => {
    if (sortBy.column === columnName) {
      return sortBy.direction === 'asc' ? <i className="fa fa-sort-up ml-1" aria-hidden="true"></i> : <i className="fa fa-sort-down ml-1" aria-hidden="true"></i>;
    }
    return <i className="fa fa-sort ml-1" aria-hidden="true"></i>; // Show disabled sort icon
  };
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };
  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handleGeneratePDFNew = async () => {
    // setLoading(true);
    try {
      const response = await http.get('/College/vendorListpdfDownload', {
        responseType: 'blob', // Expect binary response
      });
      if (response && response.data) {
        // Create a URL for the downloaded file
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        // Set the file name and download the PDF
        link.setAttribute(
          'download',
          `VendorList.pdf`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        // setLoading(false);
        toast.success('PDF generated successfully');
      }
    } catch (error) {
      //console.log("error",error);
      // setLoading(false);
      if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
        toast.error("Invalid Token");
        setTimeout(() => {
          navigate("/college/");
        }, 5000);
      }
      else if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR47") {
        toast.error(error.response.data.message);
      }
      else {
        console.error('Error generating PDF:', error);
        toast.error('Error generating PDF');
      }
    }
  };
  const handleDeleteUser = (userid) => {
    setDeleteUserID(userid);
    setDeleteUser(true);
  }
  const handleedit = (userid) => {
    navigate(`/admin/editexpertcommitteeconvenor/${userid}`);
  }
  const handleDeleteCancel = () => {
    setDeleteUser(false);
  }
  const handleCloseCreateForm = () => {
    setShowCreateForm(false);
    setReload(prev => !prev); // Refresh the list when closing
  };
  const handleViewDocument = async (encryptedFile) => {
    if (encryptedFile) {
      try {
        const res = await http.get(`College/secure_ino_pdf/${encryptedFile}`, {
          responseType: 'blob'
        });

        const blob = new Blob([res.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        setPdfUrl(url);
        setIsPDFModalOpen(true);
      } catch (error) {
        console.error('Error loading PDF:', error);
        toast.error('Failed to load PDF document');
      }
    }
  };
  const handleClosePDFModal = () => {
    setIsPDFModalOpen(false);
    if (pdfUrl) {
      window.URL.revokeObjectURL(pdfUrl);
      setPdfUrl(null);
    }
  };
  const handleDeleteSuccess = async () => {
    http
      .delete('/Admin/expert-committee-convenor/' + deleteUserID)
      .then((response) => {
        if (response.data.status_code === "MSG1") {
          setDeleteUser(false);
          sessionStorage.setItem("message", "User deleted successfully");
          toast.success("User data deleted successfully");
          setReload(prev => !prev);
        }
      })
      .catch((error) => {

        const status = error.response?.data?.http_status;
        const code = error.response?.data?.status_code;
        const message = error.response?.data?.message || "An error occurred";
        setDeleteUser(false);
        if (code === "ERR_COURSE" && status === 500) {
          toast.error("Deletion not allowed. The user has courses that are already approved.");
        } else if (code === "ERR_COURSE2" && status === 500) {
          toast.error("Action not allowed after scripts have been received by your team.");
        } else if (status === 500 || code === "ERR5") {
          toast.error("No user found");
        } else if (status === 403 && code === "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => navigate("/college/"), 5000);
        } else {
          toast.error(message);
        }
      });
  };
  const handleIsToggleStatus = async (convenorId, status) => {
    if (updatingUser === convenorId) return;

    const newStatus = status === 'active' ? 'inactive' : 'active';
    const toDate = newStatus === 'active' ? null : new Date().toISOString().split('T')[0];
    setUpdatingUser(convenorId);
    setTableData((prev) =>
      prev.map((item) =>
        item.id === convenorId ? { ...item, status: newStatus } : item
      )
    );
    try {
      await http.put(`/Admin/expert-committee-convenor/${convenorId}`, {
        status: newStatus,
        to_date: toDate,
      });
      toast.success('User status updated successfully');
    } catch (error) {
      setTableData((prev) =>
        prev.map((item) =>
          item.id === convenorId ? { ...item, status } : item
        )
      );
      toast.error(error.response?.data?.message || 'Failed to update status');
    } finally {
      setUpdatingUser(null);
    }
  };
  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#888 #f1f1f1',
    }),
    /* Additional custom scrollbar styling for WebKit-based browsers */
    multiValue: (provided) => ({
      ...provided,
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }),
  };
    const handleExpertCommitteeChange = (selectedOption) => {
    setSelectedOption(selectedOption);
  };
  return (
    <>
      <ToastContainer />
      {showCreateForm ? (
        <AddExpertCommitteeConvenor onClose={handleCloseCreateForm} />
      ) : (
        <Template>
          <div className="container-fluid">
            <div className="row">
              <div className="table-responsive">
                <div className="card">
                  <div className="col-md-12">
                    <div className="card-header">
                      <div className="py-3 d-flex justify-content-between align-items-center">
                        <h5>Expert Committee Convenors</h5>
                      </div>
                    </div>
                    <div className="card-body">


                      <div className="table-responsive">

                        <div className="card-body">
                          <div className="row align-items-end">

                            {/* SELECT BOX */}
                            <div className="col-md-6">
                              <label>Expert Committee</label>
                              <Select
                                maxMenuHeight={200}
                                menuPlacement="auto"
                                id="expert_id"
                                name="expert_id"
                                className="form"
                                styles={customStyles}
                                value={selectedExpertCommittee}
                                options={expertCommitteeData?.map(committee => ({
                                  value: committee.id,
                                  label: committee.expert_committee_name
                                }))}
                                onChange={handleExpertCommitteeChange}
                              />
                            </div>

                            {/* BUTTONS */}
                            <div className="col-md-6 d-flex justify-content-start gap-2">
                              <button
                                type="button"
                                className="btn btn-primary action-btn"
                                onClick={getConvenorListList}

                              >
                                Go
                              </button>

                              <button
                                type="button"
                                className="btn btn-secondary clear-btn btn-sm"
                                onClick={handleClearFields}
                              >
                                Clear
                              </button>
                            </div>

                          </div>
                        </div>


                        <div className="row align-items-center pdg18">
                          {/* Left 6 columns */}
                          <div className="col-md-8">

                          </div>

                          {/* Right 6 columns */}
                          <div className="col-md-4 d-flex justify-content-end">
                            <div className="d-flex gap-2">
                              <button
                                className="btn custom-btn btn-primary common-btn d-inline-flex align-items-center justify-content-center"
                                onClick={() => setShowCreateForm(true)}
                                title="Add New Convener"
                              >
                                <i className="bi bi-plus-square ctm-btn-sz m-r-5"></i>New
                              </button>                 

                            </div>
                          </div>
                        </div>

                        <div className='row'>

                              <div className='col-md-6 wdt' >
                                <p>
                                  Showing {(currentPage - 1) * 50 + 1}{''}-
                                  {Math.min((currentPage - 1) * 50 + 50, total_count)} of {total_count} entries
                                </p>
                              </div>
                              <div className='col-md-6 wdt' align='right'>
                                <input
                                  type="text"
                                  value={searchQuery}
                                  onChange={handleSearchInputChange}
                                  placeholder="Search..."
                                  className='form-control'
                                />                            
                              </div>
                        </div>

                        <div class="table-containerq" style={{ overflowX: 'unset' }}>

                          <table className="display dataTable table-striped table-bordered ex-v-table " ref={tableRef}>
                            <thead>
                              <tr className="bg-primary">

                                {/* <th onClick={() => handleSort('id')} scope="col" data-label="APAAR Id" width="8%">Sl No &nbsp;
                                  {renderSortIcon('id')} </th> */}

                                <th onClick={() => handleSort('name')} scope="col" data-label="User Type" width="" >Name 
                                  {renderSortIcon('name')} </th>

                                <th onClick={() => handleSort('email')} scope="col" data-label="User Type" width="30%" >E-mail &nbsp;
                                  {renderSortIcon('email')} </th>
                                <th onClick={() => handleSort('phone')} scope="col" data-label="User Type" width="30%" >Phone &nbsp;
                                  {renderSortIcon('phone')} </th>   

                               <th onClick={() => handleSort('expert_committee_name')} scope="col" data-label="User Type" width="30%" >Expert Code &  <br />Name &nbsp; 
                                  {renderSortIcon('expert_committee_name')} </th>


                                <th onClick={() => handleSort('year')} scope="col" data-label="User Type" width="15%" >Year&nbsp;
                                  {renderSortIcon('year')} </th>
                                <th onClick={() => handleSort('status')} scope="col" data-label="User Type" width="15%" >Status&nbsp;
                                  {renderSortIcon('status')} </th>

                                <th scope="col" data-label="Action" width="">Action</th>
                              </tr>
                            </thead>
                           <tbody>
                              {filteredAndSortedData.length > 0 ? (() => {
                                let serialNumber = (currentPage - 1) * 50 + 1;
                                // Render rows with group headers
                                return filteredAndSortedData.map((item, index) => {
                                  return (
                                    <React.Fragment key={`${item.id}-${index}`}>

                                      <tr className="grouped-row">
                                        {/* <td>{serialNumber++}</td> */}

                                        <td>{item.name}</td>
                                        <td>{item.email}</td>
                                        <td>
                                          {item.mobile && <div>{item.mobile}</div>}                                          
                                        </td>
                                        <td>{item.committee.expert_code} <br />{item.committee.expert_committee_name}</td>
                                        <td>{item.year}</td>
                                        <td>{capitalizeFirstLetter(item.status)}</td>

                                        <td>

                                          <div className="d-flex justify-content-center gap-1">

                                            {item.document && item.document[0]?.encryptedFile && (
                                              <button
                                                className="btn btn-sm btn-outline-primary btn-sm d-flex align-items-center gap-1 action-btn-compact"
                                                onClick={() => handleViewDocument(item.document[0].encryptedFile)}
                                                title="View Document"
                                              >
                                                <i className="bi bi-eye-fill"></i>
                                              </button>
                                            )}

                                            <label
                                              className={`switch m-l-10 ${updatingUser === item.id ? 'switch-loading' : ''}`}
                                              title="Activate/Deactivate User"
                                            >
                                              <input
                                                type="checkbox"
                                                checked={item.status === 'active'}
                                                onChange={() =>
                                                  handleIsToggleStatus(
                                                    item.id,
                                                    item.status
                                                  )
                                                }
                                              />
                                              <span className="slider round"></span>
                                            </label>

                                            <button
                                              className="btn btn-sm btn-outline-warning btn-sm d-flex align-items-center gap-1 action-btn-compact"
                                              onClick={() => handleedit(item.id)}
                                              title="Edit"
                                            >
                                              <i class="fa fa-edit"></i>

                                            </button>

                                            <button
                                              className="btn btn-sm btn-outline-danger btn-sm d-flex align-items-center gap-1 action-btn-compact"
                                              onClick={() => handleDeleteUser(item.id)}
                                              title="Delete"
                                            >
                                              <i className="fa fa-trash"></i>

                                            </button>

                                          </div>


                                        </td>
                                      </tr>
                                    </React.Fragment>
                                  );
                                });
                              })() : (
                                <tr>
                                  <td colSpan="8" className="text-center">No data found</td>
                                </tr>
                              )}
                            </tbody> 


                          </table>
                        </div>

                        {totalPages > 1 && (
                          <nav aria-label="..." style={{ cursor: "pointer" }}>
                            <ul className="pagination justify-content-center">
                              <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                <span className="page-link pgn-clr" onClick={handlePreviousPage}><i class="bi bi-arrow-left-circle-fill"></i></span>
                              </li>
                              <li className={`page-item`}>
                                <span className="page-link pgn-clr" onClick={() => handlePageChange(1)}>1</span>
                              </li>
                              {currentPage > 4 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}
                              {[...Array(totalPages - 1).keys()].slice(currentPage > 4 ? currentPage - 3 : 1, currentPage + 2).map((pageNumber) => (
                                <li key={pageNumber} className={`page-item ${pageNumber + 1 === currentPage ? 'act-clr' : ''}`}>
                                  <span className="page-link pgn-clr" onClick={() => handlePageChange(pageNumber + 1)}>{pageNumber + 1}</span>
                                </li>
                              ))}
                              {currentPage < totalPages - 3 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}

                              <li className={`page-item`}>
                                <span className="page-link pgn-clr" onClick={() => handlePageChange(totalPages)}>{totalPages}</span>
                              </li>

                              <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                <span className="page-link pgn-clr" onClick={handleNextPage}><i class="bi bi-arrow-right-circle-fill"></i></span>
                              </li>
                            </ul>
                          </nav>
                        )}


                        {/*  Delete User */}
                        <div className={`modal fade show ${isDeleteUser ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true">
                          <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                              <div className="modal-body">
                                <div className="modal-toggle-wrapper">

                                  <h4 className="text-center pb-2">Are you sure you want to delete?</h4>
                                  <p className="text-center">This action cannot be undone. Please confirm if you want to proceed with the deletion.</p>
                                  <div className="d-flex justify-content-center mt-3">
                                    <button className="btn btn-danger mx-2" onClick={() => handleDeleteSuccess()}>Delete</button>
                                    <button className="btn " style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }} data-bs-dismiss="modal" onClick={() => handleDeleteCancel()}>Cancel</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/*  Delete User End */}


                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Template>
      )}
      <PDFModal
        isOpen={isPDFModalOpen}
        onClose={handleClosePDFModal}
        pdfUrl={pdfUrl}
        fileName={pdfUrl ? 'Document' : ''}
      />
    </>
  );
}
